import {AffordabilityAssessmentAPI} from "./affordabilityAssessmentAPI"
import {PartialPaymentAPI} from "./partialPaymentAPI"
import {MetadataAPI} from "./metadataAPI"
import {OptOutAPI} from "./optOutAPI"
import {NotificationOfAssignmentAcknowledgementAPI} from "./notificationOfAssignmentAcknowledgementAPI"
import {TransactionalEmailOptOutAPI} from "./transactionalEmailOptOutAPI"
import {
	setRegionFromAWSRegion,
	setRegionFromSecureCode,
	setRegionFromRegionNumber,
	getRegionAWSName,
	Regions,
	RegionNumberMap,
	regionManager,
	getRegionNumber,
} from "./regionManager"

const affordabilityAssessmentAPI = AffordabilityAssessmentAPI()
const partialPaymentAPI = PartialPaymentAPI()
const metadataAPI = MetadataAPI()
const optOutAPI = OptOutAPI()
const notificationOfAssignmentAcknowledgementAPI = NotificationOfAssignmentAcknowledgementAPI()
const transactionalEmailOptOutAPI = TransactionalEmailOptOutAPI()

export {
	partialPaymentAPI,
	metadataAPI,
	affordabilityAssessmentAPI,
	optOutAPI,
	notificationOfAssignmentAcknowledgementAPI,
	transactionalEmailOptOutAPI,
	setRegionFromAWSRegion,
	setRegionFromSecureCode,
	setRegionFromRegionNumber,
	getRegionAWSName,
	Regions,
	RegionNumberMap,
	regionManager,
	getRegionNumber,
}
